import CONST from "./Constant";

export const INITIAL_STATE = {
    user:{},
    tenant:{},
    isLoggedIn:false,
    error:undefined,
    fetching:false,
    otpSent: false,
};

const Reducer = (state = INITIAL_STATE, action) => {

    const originalData = action?.payload?.data;
    const user = { ...originalData }; // shallow clone
    const tenant = user.tenant;
    delete user.tenant;

    switch (action.type){

        case CONST.REFRESH_USER_SUCCESS:
            return {
                ...state,
                user: user,
                tenant: tenant,
            }
        case CONST.REFRESH_USER_FAILED:
            return {
                ...state,
                error: action.payload,
                fetching: false
            }
        case CONST.REGISTER_USER_SUCCESS:
            return {
                ...state,
                user: user,
                isLoggedIn:false,
                error: undefined,
                fetching: false
            }
        case CONST.REGISTER_USER_FAILED:
            return {
                fetching: false,
                error: action.payload
            }
        case CONST.VERIFY_OTP_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }
        case CONST.VERIFY_OTP_SUCCESS:
            // const tenant1 = action.payload.data.tenant;
            // delete action.payload.data.tenant;
            return {
                ...state,
                user: user,
                tenant: tenant,
                isLoggedIn:true,
                error: undefined,
                fetching: false,
            }
        case CONST.START_PROCESS_SUCCESS:
            return {
                ...state,
                tenant: action.payload.data ? action.payload.data : {},
            }
        case CONST.LOGIN_SUCCESS:
            return {
                user,
                tenant,
                isLoggedIn: true,
                error: undefined,
                fetching: false,
            };
        case CONST.LOGIN_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }
        case CONST.MARK_NOTIFICATION_READ_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    notifications: []
                }
            }
        case CONST.MARK_NOTIFICATION_READ_FAILED:
            return {
                ...state,
                error: action.payload
            }
        case CONST.RESEND_OTP_SUCCESS:
            return {
                ...state,
                otpSent: true,
            }
        case CONST.LOGIN_LOADING:
            return {
                fetching: true
            }
        case CONST.FORGOT_PASSWORD_SUCCESS: {
            const data = action.payload?.data ?? {};
            return {
                ...state,
                user: {
                    ...state.user,
                    id: data.user_id,
                    email: data.email,
                },
            };
        }
        case CONST.FORGOT_PASSWORD_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };
        case CONST.LOGOUT_SUCCESS:
            return INITIAL_STATE;
        case CONST.LOGOUT_FAILED:
            return {
                fetching: false,
                error: action.payload
            }
        case CONST.LOGOUT_LOADING:
            return {
                fetching: true
            }
        case CONST.REFRESH_TOKEN_LOADING:
            return {
                ...state,
                user: action.payload.user,
                isLoggedIn: true,
                // Token is now stored in httpOnly cookies, not Redux state
                error: undefined,
                fetching: false
            }
        default:
            return state;
    }
}

export default Reducer;